import React from "react";
import {Link} from "react-router-dom";
import ReactTable from "react-table";
import {Button} from "reactstrap";
import classNames from 'classnames';

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {confirmAlert} from "react-confirm-alert";
import {PrintBarcodeModal} from '../../containers/Print';
import ProductLong from "components/Labels/ProductLong";
import ProductShort from "components/Labels/ProductShort";

import Select from "react-select";
import CollectionOverride from "components/CollectionOverride";
import {isEmpty} from "lodash";


export default class Products extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Products._name, API.RequestType.READ_ALL);
		super(props, model);

		this.state.caliber = '';
		this.state.caliber_error = '';
		this.state.calibers = null;
		this.state.manufacturer = '';
		this.state.manufacturer_error = '';
		this.state.manufacturers = null;
		this.state.type = '';
		this.state.type_error = '';
		this.state.types = null;
	}


	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if(this.props.setTotalCount && (this.state.totalCount !== prevState.totalCount) && typeof this.state.totalCount !== 'undefined' && !this.isFilterEmpty()) {
			this.props.setTotalCount(this.state.totalCount);
		}

		if(this.props.setTotalCount && (this.state.totalCount !== prevState.totalCount) && typeof this.state.totalCount !== 'undefined' && this.isFilterEmpty()) {
			this.props.setTotalCount(0);
		}

	}


    isFilterEmpty = () => {
		let filter = this.state.filter;
		if (Object.keys(filter).length === 0) {
			return true;
		}

		return Object.values(filter).every(value => {
			if (value === "") return true;
			if (value === null || value === undefined) return true;

			return Array.isArray(value) && value.length === 0;

		});
	};

	customStyles = {
		menu: (provided) => ({
			...provided, zIndex: 9999
		})
	};

	printLabel = (e) => {
		const {data} = this.state;
		let pkey = e.currentTarget.id;
		let binary_id = e.currentTarget.getAttribute('data-binary-id');
		let product;
		let longBarCode, shortBarCode;
		switch (pkey) {
			case 'all':
				longBarCode = data.map((product, key) => <ProductLong key={key} product={product}/>)
				shortBarCode = data.map((product, key) => <ProductShort key={key} product={product}/>)
				break;
			default: {
				pkey = parseInt(pkey);
				product = data.find((item) => item.pkey === pkey && item.binary_id === binary_id);
				longBarCode = <ProductLong product={product}/>
				shortBarCode = <ProductShort product={product}/>
			}
		}

		confirmAlert({
			customUI: ({onClose}) => {
				return (
					<PrintBarcodeModal
						onClose={onClose}
						longBarCode={longBarCode}
						shortBarCode={shortBarCode}
						showFullLabel={true}
					/>
				);
			}
		});
	};

	handleSelectPropertyUpdate = (property, value, linked, object) => {
		let updatedState;
		if (linked) {
			if (object && object.hasOwnProperty('binary_id')) {
				updatedState = {
					[linked]: object,
					[property]: value,
				};
			} else {
				updatedState = {
					[linked]: object,
					[property]: value,
				};
			}
		} else {
			updatedState = {
				[property]: value,
			};
		}
		this.setState(updatedState);
		this.doFilter({'value': value}, {'name': property});
	};

	clearFilters = () => {
		this.setState({
			key: Math.random(),
			filter: {},
			search: '',
			startDate: '',
			endDate: '',
			filterLocation: null,
			filterStatus: null,
			filterUsed: null,

			caliber: '',
			calibers: null,
			manufacturer: '',
			manufacturers: null,
			type: '',
			types: null,
		});
		let path = window.location.pathname.replaceAll('/', ' ').titleCase().replaceAll(' ', '');
		localStorage.removeItem('table-preferences-' + path);
	}

	handleShowDuplicates = async () => {
		this.setState({loading: true})
		this.request = 'GET_ALL_PRODUCTS_DUPLICATES';
		this.model.filter = {};
		let data = await this.model.submit(null, 'GET_ALL_PRODUCTS_DUPLICATES');
		let pages = Math.ceil(data.total/this.state.limit);
		this.setState({data: data.items, loading: false, pages})


	}

	handleShowRegular = async () => {
		this.setState({loading: true})
		this.request = 'GET_ALL';
		this.model.filter = {};
		let data = await this.model.submit(null, 'GET_ALL');
		let pages = Math.ceil(data.total/this.state.limit);
		this.setState({data: data.items, loading: false, pages})
	}

	render() {
		const {data, pages, limit, loading,columnsAnchor} = this.state;
		const extraColumns = [
			{
				Header: "ID",
				id: "pkey",
				accessor: obj => (obj.id ? obj.id : (obj.binary_id + '-' + obj.pkey)),
				show: !!this.state['column_id'],
				toggle: 'column_id'
			},
			{
				Header: 'Cost',
				id:"cost",
				accessor:obj => (obj.cost ),
				show: !!this.state['column_price_cost'],
				toggle: 'column_price_cost'
			},
			{
				Header: 'Sale Price',
				id:"price_sale",
				accessor:obj => (obj.price_sale ),
				show: !!this.state['column_price_sale'],
				toggle: 'column_price_sale'
			},
			{
				Header: 'Min Price',
				id:"price_min",
				accessor:obj => (obj.price_min ),
				show: !!this.state['column_price_min'],
				toggle: 'column_price_min'
			},
			{
				Header: 'List Price',
				id:"price_list",
				accessor:obj => (obj.price_list ),
				show: !!this.state['column_price_list'],
				toggle: 'column_price_list'
			},
			{
				Header: 'Used',
				id:"used_firearm",
				accessor:obj => (obj.used_firearm ? 'Used' : 'New' ),
				show: !!this.state['column_used_firearm'],
				toggle: 'column_used_firearm'
			},
		];
		const columns = [

			{
				Header: "SKU",
				accessor: "sku",
			},
			{
				Header: "Type",
				accessor: "type",
			},
			{
				Header: "Model",
				accessor: "model",
			},
			{
				Header: "Serial",
				accessor: "serial_number",
			},
			{
				Header: "Manufacturer",
				id: 'manufacturer',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.manufacturer ? obj.manufacturers.name : obj.manufacturer_other)
			},
			{
				Header: "Caliber",
				id: 'caliber',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.caliber ? obj.calibers.name : obj.caliber_other)
			},
			...extraColumns,
			{
				Header: "Status",
				id: 'status',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.status ? obj.product_statuses.name : "")
			},
			{
				Header: "Location",
				id: 'location',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.location ? obj.locations.name_display || obj.locations.name : "")
			},
			{
				Header: "Acq. Date",
				id: "acquisition_date",
				width: 160,
				/** @param {Products_Object} obj */
				accessor: obj => {
					return obj.acquisition_date ? moment(obj.acquisition_date)
						.local()
						.format("MM/DD/YYYY") : 'Never Acquired'
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Button
								id={props.original.pkey}
								data-binary-id={props.original.binary_id}
								color="blue-hoki"
								size={"sm"}
								block={true}
								onClick={this.printLabel}
							>
								<i className={"fa fa-print"}/>
							</Button>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/products/${props.original._id}`}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className={"fa fa-pencil"}/></Button>
							</Link>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/products/${props.original._id}#history`}>
								<Button color="default" size={"sm"} block={true}>
									<i className={"fa fa-file-text-o"}/></Button>
							</Link>
						</span>
					);
				}
			},
		];
		/** @type {Products_Properties} properties */
		let properties = this.model.properties;
		/** @type {Products_Object} object */
		let object = this.state;

		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Products', "")}
								{this.renderLocationFilter()}
								<div className="statusFilter" style={{width: '160px'}}>
									<Select
										styles={this.customStyles}
										className={classNames('basic-single', {hasSelection: this.state.filter.status != null && this.state.filter.status.length})}
										classNamePrefix="select"
										onChange={this.doFilter}
										value={this.state.filterStatus}
										isClearable={true}
										isSearchable={true}
										name="status"
										placeholder={"Status..."}
										options={[
											{value: null, label: 'All'},
											{value: 1, label: 'In Stock'},
											{value: 2, label: 'Sold'},
											{value: 3, label: 'Transferred'},
											{value: 5, label: 'Lost'},
											{value: 6, label: 'Reserved'},
											{value: 7, label: 'Destroyed'},
											// {value: 8, label: 'Never Acquired'},
											{value: 9, label: 'Rented'},
										]}
									/>
								</div>
								<div className="statusFilter" style={{width: '110px'}}>
									<Select
										styles={this.customStyles}
										className={classNames('basic-single', {hasSelection: this.state.filter.used_firearm != null && this.state.filter.used_firearm.length})}
										classNamePrefix="select"
										onChange={this.doFilter}
										value={this.state.filterUsed}
										isClearable={true}
										isSearchable={true}
										name="used_firearm"
										placeholder={"Used..."}
										options={[
											{value: null, label: 'All'},
											{value: false, label: 'New'},
											{value: true, label: 'Used'},
										]}
									/>
								</div>
								<div className={"statusFilter"}>
									<Framework.Elements.Select
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										name="caliber"
										property={properties.caliber}
										value={object.caliber}
										error={object.caliber_error}
										object={object.calibers}
										nullable={true}
									/>
								</div>
								<div className={"statusFilter"}>
									<Framework.Elements.Select
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										name="manufacturer"
										property={properties.manufacturer}
										value={object.manufacturer}
										error={object.manufacturer_error}
										object={object.manufacturers}
										nullable={true}
									/>
								</div>
								<div className={"typeFilter"}>
									<Framework.Elements.Select
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										name="type"
										property={properties.type}
										value={object.type}
										error={object.type_error}
										model={Types.Products_Types._name}
										id={'name'}
										nullable={true}
									/>
								</div>
								{this.request === 'GET_ALL_PRODUCTS_DUPLICATES' ? <Button color="primary" onClick={this.handleShowRegular} style={{marginLeft: '25px'}}>Regular</Button> :
									<Button color="warning" onClick={this.handleShowDuplicates} style={{marginLeft: '25px'}}>Duplicates</Button> }
								{this.renderHeaderRight("Products", columns, extraColumns, columnsAnchor, this.handleOpen, this.handleClose,
									<button id="all" onClick={this.printLabel} className="btn btn-default" style={{whiteSpace: 'nowrap'}}>
										<span className="truncatedText">Print</span>
										<span className="fullText">Print Labels</span>
									</button>
									)}
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							pageSizeOptions={[5, 10, 20, 25, 50, 100, 500, 1000, 'All']}
							renderPageSizeOptions={this.renderPageSizes}
							pageSize={limit}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
